import * as ScoreType from '../../../../../../constants/ScoreType';
import { Map } from 'immutable';
export function getSoccerScores(scores) {
    var defaultScore = new Map({ score1: 0, score2: 0 });
    var matchScores = (scores.filter(function (score) { return score.get('type') == ScoreType.Match; }).first() || defaultScore).toJS();
    var extraTimeScore = (scores.filter(function (score) { return score.get('type') == ScoreType.ExtraTime; }).first() || defaultScore).toJS();
    var firstTeamTotal = (matchScores.score1 + (extraTimeScore.score1 || 0));
    var secondTeamTotal = (matchScores.score2 + (extraTimeScore.score2 || 0));
    return {
        firstTeamTotal: isNaN(firstTeamTotal) ? '' : firstTeamTotal,
        secondTeamTotal: isNaN(secondTeamTotal) ? '' : secondTeamTotal,
    };
}



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/statistics/mainScores/soccer.js